import Vue from 'vue/dist/vue.esm.js'
import store from '../../stores/report_rows_store.js.coffee'

KCVS.Views.ReportRowsIndexView = Vue.extend(
  store: KCVS.Stores.ReportRowsStore
  created: ->
    @$store.state.projectPartnerReportPeriodId = @projectPartnerReportPeriodId
    @$store.state.periodClosed = @periodClosed
    @$store.state.projectPartnerId = @projectPartnerId
    @$store.state.informativeFields = @informativeFields

  data: ->
    currentView: 'invoice-rows'
  components:
    'invoice-rows': KCVS.Views.ReportInvoiceRowsTable
    'agreement-rows': KCVS.Views.ReportAgreementRowTable
    'involved-employee-rows': KCVS.Views.ReportInvolvedEmployeeRowTable
    'icebox-rows': KCVS.Views.IceboxRowsTable

  methods:
    switchView: (view) ->
      @currentView = view
)
